import React from 'react'

function TenderTextWFZ() {
  return (
    <embed src="\pdfs\EA1.8_wfz_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextWFZ